export const CURRENT_APP = 'website' as const;

export const PLATFORM_PATHS = {
  subscription_manage: '/tenant/subscription',
  referrals_manage: '/tenant/referrals',
  choose_plan: '/subscription/choose-plan',
  checkout: '/checkout',
  payment_result: '/checkout',
  pricing: '/pricing',
  payment_recovery: '/payments/recover',
  invoices: '/tenant/subscription',
  profile: '/tenant/profile',
} as const;

export type PlatformAction = keyof typeof PLATFORM_PATHS;

export function platformPath(action: PlatformAction): string {
  return PLATFORM_PATHS[action];
}

export function isSafeInternalPath(path: string | null | undefined): path is string {
  return typeof path === 'string' && /^\/(?!\/)/.test(path) && !/[\\\u0000-\u0020\u007f]/.test(path) && !/%(?:2f|5c|0[0-9a-f]|1[0-9a-f]|20|7f)/i.test(path.split(/[?#]/, 1)[0]);
}

export function resolveInAppPath(candidate: string | null | undefined, fallback: PlatformAction): string {
  return isSafeInternalPath(candidate) ? candidate : platformPath(fallback);
}
